import { FlexBox } from 'shared/components/Base/Base'
import { Text } from 'shared/components/Text/Text'
import { formatCurrency } from 'shared/helpers/formatters'
import { HandlerOf } from 'shared/helpers/typeHelper'
import { fieldToTitleCase, toSentenceCase } from 'shared/helpers/utils'
import { darkGray, lightGray2, midGray, primaryBlack, royalBlue } from 'shared/theme/colors'
import { header4 } from 'shared/theme/typography'
import styled from 'styled-components'

import { JobStatusDetail } from '../../../helpers/constants'
import { formatTripRate } from '../../../helpers/jobs'
import { getFormattedDate } from '../../../helpers/utils'
import { Job } from '../../../models/jobs'
import { AutoBidInfo, HistoryItem } from '../../Common/AutoBidInfo'
import { JobBidModal } from '../JobBidModal'

interface JobDetailsLoadInfoProps {
  job: Job
  bids: any[]
  setBids: HandlerOf<any>
}

export function JobDetailsLoadInfo({ job, bids, setBids }: JobDetailsLoadInfoProps) {
  const bidHistory = job?.contacted_load?.bid_history
  const isActiveNegotiation = job?.status_detail === JobStatusDetail.ActiveNegotiation
  const hasBidHistory = bidHistory && bidHistory.length > 0
  const latestBid = bids.length > 0 ? bids[0] : null
  const bidMinimum = job?.contacted_load?.bid_minimum
  const bidMaximum = job?.contacted_load?.bid_maximum

  return (
    <FlexBox isColumn gap="20px">
      <FlexBox justifyContent="space-between" gap="20px">
        <Text variant="header3" fontColor={darkGray}>
          {job.load.equipment.map((equipment) => toSentenceCase(fieldToTitleCase(equipment))).join(', ')}
        </Text>
        {job.confirmed_rate === undefined || job.confirmed_rate === null ? (
          <>
            <Text variant="header3" fontColor={darkGray}>
              {formatCurrency(job.rate_per_mile)}/mi
            </Text>
            <FlexBox isColumn>
              <Text variant="header3" fontColor={darkGray}>
                {formatTripRate(job.confirmed_rate)}
              </Text>
              <Text variant="label4" fontColor={midGray}>
                Confirmed
              </Text>
            </FlexBox>
          </>
        ) : (
          <>
            <Text variant="header3" fontColor={lightGray2}>
              rate not confirmed
            </Text>
          </>
        )}
      </FlexBox>
      <Text variant="header3" fontColor={darkGray}>
        {toSentenceCase(fieldToTitleCase(job.booking_type))}
      </Text>

      {(isActiveNegotiation || hasBidHistory) && (
        <FlexBox mr={2} isFullWidth>
          {isActiveNegotiation && (
            <>
              {latestBid && (
                <FlexBox isColumn gap="8px" isFullWidth>
                  <FlexBox isFullWidth justifyContent="space-between">
                    <Text variant="header4" fontColor={primaryBlack}>
                      Latest ${latestBid.amount}
                    </Text>
                    <StyledJobBidModal record={job} bids={bids} setBids={setBids} />
                  </FlexBox>
                  <FlexBox isColumn>
                    <Text variant="paragraph2" fontColor={darkGray}>
                      {latestBid.notes}
                    </Text>
                    <Text variant="paragraph2" fontColor={darkGray}>
                      {latestBid.created_by.email}
                    </Text>
                    <Text variant="paragraph2" fontColor={darkGray}>
                      {getFormattedDate(latestBid.date_created)}
                    </Text>
                  </FlexBox>
                </FlexBox>
              )}
            </>
          )}
          {hasBidHistory && (
            <AutoBidInfo
              history={bidHistory as HistoryItem[]}
              bidMinimum={bidMinimum}
              bidMaximum={bidMaximum}
            />
          )}
        </FlexBox>
      )}
    </FlexBox>
  )
}

const StyledJobBidModal = styled(JobBidModal)`
  padding: 0;

  span {
    ${header4};
    text-transform: capitalize;
    color: ${royalBlue};
  }
`
